import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import logoLight from "../../Assets/images/Omphalos-small.png";
import { toast } from "react-toastify";
import "../../STYLE/LoginPage.css";
import {
  EMAIL_LABEL,
  EMPTY_STRING,
  FORGOT_PASS_QUE,
  LOGIN_TITLE,
  OMPHALOS_LABEL,
  PASSWORD_LABEL,
  SIGNIN,
  WELCOME_BACK,
} from "Components/constants/commonNames";
import { LOGIN_USER_COMMON } from "API/Services/common";
import BaseButton from "../../Components/Common/BaseButton";
import BaseInput from "../../Components/Common/BaseInput";
import {
  checkStatusCodeSuccess,
  SESSION_SET_ITEM,
} from "Components/constants/enums";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  EMAIL_REGEX,
  InputPlaceHolder,
  validationMessages,
} from "Components/constants/validation";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(EMAIL_REGEX, validationMessages.format(EMAIL_LABEL))
    .required(validationMessages.required(EMAIL_LABEL)),
  password: Yup.string().required(validationMessages.required(PASSWORD_LABEL)),
});

const Login = (props: any) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState<boolean>(false);

  const initialValues = {
    email: "",
    password: "",
    type: "",
  };

  const handleSubmit = async (values: typeof initialValues) => {
    setLoader(true);
    const payload = {
      email: values.email,
      password: values.password,
      type: OMPHALOS_LABEL,
    };

    try {
      const resp: any = await LOGIN_USER_COMMON(payload);
      if (checkStatusCodeSuccess(resp?.statusCode)) {
        toast.success(resp?.message);
        const token = resp?.data;
        const userData = resp;

        SESSION_SET_ITEM("authToken", token);
        SESSION_SET_ITEM("authUser", JSON.stringify(userData));
        navigate("/dashboard");
      } else {
        toast.error(resp?.message);
      }
    } catch (error: any) {
      toast.error(error.response?.data?.message);
    } finally {
      setLoader(false);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    document.title = LOGIN_TITLE;
  }, []);

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container className="mt-5">
            <Row>
              <Col lg={12}>
                <div className="text-center mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" className="logocss" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-2 login-card">
                  <CardBody className="p-4 ">
                    <div className="text-center mt-2">
                      <span className="text-info hello ">{WELCOME_BACK}</span>
                    </div>
                    <div className="p-2 ">
                      <form onSubmit={formik.handleSubmit}>
                        <BaseInput
                          label={EMAIL_LABEL}
                          name="email"
                          type="email"
                          className="mb-3"
                          placeholder={InputPlaceHolder(EMAIL_LABEL)}
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={formik.errors.email}
                          touched={formik.touched.email}
                        />
                        <div className="float-end">
                          <Link to="/forgot-password" className="forgoque">
                            {FORGOT_PASS_QUE}
                          </Link>
                        </div>
                        <BaseInput
                          label={PASSWORD_LABEL}
                          name="password"
                          type="password"
                          placeholder={InputPlaceHolder(PASSWORD_LABEL)}
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          className="mb-3"
                          error={formik.errors.password}
                          touched={formik.touched.password}
                          showPasswordToggle={true}
                        />
                        <div className="mt-0">
                          <BaseButton
                            text={loader ? EMPTY_STRING : SIGNIN}
                            loading={loader}
                            type="submit"
                            color="info"
                          />
                        </div>
                      </form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
